import { isDefined } from '@fi-shared/utils/is-defined';

export function traverseDom(root, callback, nodeTypes?) {
    if (!isDefined(nodeTypes)) {
        nodeTypes = [1];
    }
    var nodes = [root];
    var current;

    // nodes should be processed in backward order to proper height and appearance calculation
    var processNodes = [];
    while (nodes.length) {
        current = nodes.pop();
        if (nodeTypes.length == 0 || nodeTypes.indexOf(current.nodeType) > -1) {
            processNodes.unshift(current);
        }

        if (current.nodeType == 1) {
            var childNodes = Array.prototype.slice.call(current.childNodes);
            childNodes.forEach(function (node) {
                nodes.push(node);
            });
        }
    }

    processNodes.forEach(callback);
}
